import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const UserProfileWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-100 overflow-hidden h-full p-6" data-id="element-757">
      <div className="flex flex-col h-full" data-id="element-758">
        <div className="flex items-center mb-4" data-id="element-759">
          <div className="w-28 h-28 rounded-full overflow-hidden border-2 border-green-600 flex-shrink-0" data-id="element-760">
            <img src="https://cdn.magicpatterns.com/uploads/wAuXNp8Njv5DkmF4gEUeC7/jonathan-cooper-ViyA5myhBVw-unsplash.jpg" alt="Alex Rossi" className="w-full h-full object-cover" data-id="element-761" />
          </div>
          <div className="ml-4" data-id="element-762">
            <h3 className="text-base font-normal text-gray-900" data-id="element-763">Alex Rossi</h3>
            <p className="text-sm text-gray-600 font-normal" data-id="element-764">Ricercatore PhD</p>
            <p className="text-sm text-gray-500 font-normal" data-id="element-765">Milano, Italia</p>
          </div>
        </div>
        <div className="text-sm text-gray-600 font-normal mb-4 leading-relaxed" data-id="element-766">
          Ricercatore in scienze ambientali con focus su cambiamento climatico e
          transizione energetica. Appassionato di divulgazione scientifica e
          soluzioni pratiche per la sostenibilità.
        </div>
        <div className="flex flex-wrap gap-2 mb-6" data-id="element-767">
          <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-normal" data-id="element-768">
            Climate Science
          </span>
          <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-normal" data-id="element-769">
            Energia Rinnovabile
          </span>
          <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-normal" data-id="element-770">
            Ricerca Ambientale
          </span>
          <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-normal" data-id="element-771">
            Divulgazione
          </span>
        </div>
        <div className="mt-auto" data-id="element-772">
          <Link to="/public-profile" className="w-full flex items-center justify-center py-2 bg-green-600 text-white rounded-lg transition-colors hover:bg-green-700 font-normal text-sm" data-id="element-773">
            <ExternalLinkIcon size={16} className="mr-2" strokeWidth={1.5} data-id="element-774" />
            Profilo Pubblico
          </Link>
        </div>
      </div>
    </div>;
};
export default UserProfileWidget;